import keys from '@debbie/common/dist/cache/keys.js';
import { deletionReasonLabels, } from '@debbie/common/dist/debt-register/deletion-reason.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { parseOrStr } from '@debbie/common/dist/util/index.js';
import { casesEntity, ensureCaseLoaded, } from '@debbie/cortex/dist/cases/index.js';
import { customersEntity, ensureCustomerLoaded, } from '@debbie/cortex/dist/customers/index.js';
import { ensureRegistriesByCaseIdLoaded, registriesEntity, } from '@debbie/cortex/dist/debt-registries/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorNotification } from '../../utils/errors.js';
import { Button, Modal, Select } from '../index.js';
import { getDescriptor } from './registries.js';
const DeleteModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [deleteReason, setDeleteReason] = useState(null);
    const descriptor = getDescriptor(props.registry);
    const deleteMutation = useMutation(async () => {
        if (!props.userId) {
            throw new Error('Ingen debitor valgt.');
        }
        if (!deleteReason) {
            throw new Error('Ingen sletteårsag valgt');
        }
        if (!props.registrationId) {
            throw new Error('Intet registrerings-ID valgt.');
        }
        const deleteAction = descriptor.actions.delete;
        if (!deleteAction) {
            throw new Error('Sletning understøttes ikke af dette register.');
        }
        await deleteAction.call(props.userId, props.case.caseId, props.registrationId, deleteReason);
        q.invalidate(keys.write.modify(casesEntity, props.case.caseId));
        q.invalidate(keys.write.modify(customersEntity, props.customer.customerId));
        q.invalidate(keys.write.create(registriesEntity));
        await ensureCaseLoaded(props.case.caseId);
        await ensureRegistriesByCaseIdLoaded(props.case.caseId);
        await ensureCustomerLoaded(props.customer.customerId);
        props.toggleDeleteModal();
    }, {
        onError: (error) => {
            const err = 'message' in error ? parseOrStr(error.message) : error;
            errorNotification(lang, err, 'delete', descriptor.errorEntity(lang), typeof err === 'object' && 'description' in err
                ? err.description
                : String(err));
        },
    });
    const header = descriptor.deleteHeader(lang);
    return (React.createElement(Modal, { header: header, onToggle: props.toggleDeleteModal, maxWidth: "350px" },
        React.createElement(Select, { onChange: (e) => setDeleteReason(e.target.value), value: deleteReason },
            React.createElement("option", { value: "" }, "- V\u00E6lg \u00E5rsag -"),
            (descriptor.actions.delete?.supportedDeleteReasons ?? []).map((reason) => (React.createElement("option", { key: reason, value: reason }, deletionReasonLabels[reason])))),
        React.createElement(Button, { disabled: !deleteReason, loading: deleteMutation.isLoading, block: true, onClick: () => deleteMutation.mutate() }, header)));
};
export default DeleteModal;
//# sourceMappingURL=DeleteModal.js.map